import { createStore } from "vuex";
import cart from "@/store/module/cart";
import router from "@/router";
import httpClient from "@/API/HttpClient";
import { getUser, login, verifyPhone } from "@/API/API";

export default createStore({
  state: {
    token: localStorage.getItem("token") || "",
    user: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {},
    factor: {
      tedad: "",
      desK_NUMBER: "",
      description: "",
    },
    factorSum: {
      discount: "",
      paymentBeforDiscount: "",
      paymentAfterDiscount: "",
      tax: "",
      paymentAfterTax: "",
    },
    hsale: {
      sho_Mobile: "",
      discount: 0,
      locationCode: 0,
      tedad: 0,
      taF_NAME: "",
      orderType: "restaurant",
      desK_NUMBER: 0,
      deliveryDelay: "",
      goods: [],
      companions: "",
      factoR_ID: 0,
      payed: "",
      printeR_PORTABLE: "",
      printeR_KITCHEN: "",
      printeR_CASH: "",
      captaiN_ID: "",
      prinT_STATUS: "",
      paymenT_STATUS: "",
      saloonID: "",
      saloonName: "",
      mobile: "",
      description: "",
      maliat: 0,
      maB_WITH_MALIAT: 0,
      timE_FACTOR: "",
      datE_FACTOR: "",
      prinT_STATUS_CODE: 0,
      pardakhT_STATUS: "",
      pardakhT_STATUS_CODE: 0,
      iranI_STATUS: "",
      farangI_STATUS: "",
      paymentType: "",
      iranI_STATUS_CODE: 0,
      farangI_STATUS_Code: 0,
      paymessage: "",
      systemGOODS: [],
    },
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    REMOVE_TOKEN(state) {
      state.token = "";
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
    SET_USER(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    SET_FACTOR(
      state,
      {
        user,
        description,
        tableNumber,
        goods,
        orderType,
        paymentType,
        discount,
      }
    ) {
      state.factor.sho_Mobile = user.phonE_NUMBER;
      state.factor.taF_NAME = user.name;
      state.factor.tedad = user.count;

      state.factor.description = description;
      state.factor.desK_NUMBER = tableNumber;
      state.factor.goods = goods;
      state.factor.orderType = orderType;
      state.factor.paymentType = paymentType;
      state.factor.discount = discount;
    },
    SET_LOCATION(state, { tableNumber, location }) {
      state.factor.desK_NUMBER = tableNumber;
      state.factor.saloonID = location;
    },
    REMOVE_FACTOR(state) {
      state.factor = {};
    },
    SET_NEW_FACTORSUM(
      state,
      {
        discount,
        paymentBeforDiscount,
        paymentAfterDiscount,
        tax,
        paymentAfterTax,
      }
    ) {
      state.factorSum.discount = discount;
      state.factorSum.paymentBeforDiscount = paymentBeforDiscount;
      state.factorSum.paymentAfterDiscount = paymentAfterDiscount;
      state.factorSum.tax = tax;
      state.factorSum.paymentAfterTax = paymentAfterTax;
    },
    SET_NEW_FACTORHSALE(
      state,
      {
        sho_Mobile,
        discount,
        locationCode,
        tedad,
        taF_NAME,
        orderType,
        desK_NUMBER,
        deliveryDelay,
        goods,
        companions,
        factoR_ID,
        payed,
        printeR_PORTABLE,
        printeR_KITCHEN,
        printeR_CASH,
        captaiN_ID,
        prinT_STATUS,
        paymenT_STATUS,
        saloonID,
        saloonName,
        mobile,
        description,
        maliat,
        maB_WITH_MALIAT,
        timE_FACTOR,
        datE_FACTOR,
        prinT_STATUS_CODE,
        pardakhT_STATUS,
        pardakhT_STATUS_CODE,
        iranI_STATUS,
        farangI_STATUS,
        paymentType,
        iranI_STATUS_CODE,
        farangI_STATUS_Code,
        paymessage,
        systemGOODS,
      }
    ) {
      state.hsale.sho_Mobile = sho_Mobile;
      state.hsale.discount = discount;
      state.hsale.locationCode = locationCode;
      state.hsale.tedad = tedad;
      state.hsale.taF_NAME = taF_NAME;
      state.hsale.orderType = orderType;
      state.hsale.desK_NUMBER = desK_NUMBER;
      state.hsale.deliveryDelay = deliveryDelay;
      state.hsale.goods = goods;
      state.hsale.companions = companions;
      state.hsale.factoR_ID = factoR_ID;
      state.hsale.payed = payed;
      state.hsale.printeR_PORTABLE = printeR_PORTABLE;
      state.hsale.printeR_KITCHEN = printeR_KITCHEN;
      state.hsale.printeR_CASH = printeR_CASH;
      state.hsale.captaiN_ID = captaiN_ID;
      state.hsale.prinT_STATUS = prinT_STATUS;
      state.hsale.paymenT_STATUS = paymenT_STATUS;
      state.hsale.saloonID = saloonID;
      state.hsale.saloonName = saloonName;
      state.hsale.mobile = mobile;
      state.hsale.description = description;
      state.hsale.maliat = maliat;
      state.hsale.maB_WITH_MALIAT = maB_WITH_MALIAT;
      state.hsale.timE_FACTOR = timE_FACTOR;
      state.hsale.datE_FACTOR = datE_FACTOR;
      state.hsale.prinT_STATUS_CODE = prinT_STATUS_CODE;
      state.hsale.pardakhT_STATUS = pardakhT_STATUS;
      state.hsale.pardakhT_STATUS_CODE = pardakhT_STATUS_CODE;
      state.hsale.iranI_STATUS = iranI_STATUS;
      state.hsale.farangI_STATUS = farangI_STATUS;
      state.hsale.paymentType = paymentType;
      state.hsale.iranI_STATUS_CODE = iranI_STATUS_CODE;
      state.hsale.farangI_STATUS_Code = farangI_STATUS_Code;
      state.hsale.paymessage = paymessage;
      state.hsale.systemGOODS = systemGOODS;
      console.log(state.hsale);
    },
  },
  actions: {
    login(state, phone) {
      return new Promise((resolve, reject) => {
        login(phone)
          .then((resp) => {
            console.log(resp)
            return resolve(resp.data.verify_token);
          })
          .catch(() => {
            return reject;
          });
      });
    },
    verifyPhone({ commit }, { phone, verificationCode }) {
      const params = new FormData();
      params.append("Grant_Type", "takhtjamshid");
      params.append("Client_Id", "takhtjamshid");
      params.append("Client_Secret", process.env.VUE_APP_CLIENT_SECRET);
      params.append("scope", "myapi");
      params.append("phone_number", phone);
      params.append("verification_token", verificationCode);

      return new Promise((resolve, reject) => {
        verifyPhone(params)
          .then((resp) => {
            console.log(resp);
            commit("SET_TOKEN", resp.data.access_token);
            httpClient.defaults.headers.common["Authorization"] =
              "Bearer " + resp.data.access_token;
            getUser().then((resp) => {
              commit("SET_USER", resp.data.result);
              resolve();
            });
          })
          .catch(e => {
            console.log(e);
            reject();
        });
          // .catch(() => {
          //   console.log("یییی");
          //   reject();
          // });
      });
    },
    logout({ commit }) {
      commit("REMOVE_TOKEN");
      router.push("/login?reLogin=true");
    },
    setUser({ commit }, user) {
      commit("SET_USER", user);
    },
    setFactor(
      { commit },
      {
        user,
        description,
        tableNumber,
        goods,
        orderType,
        paymentType,
        discount,
      }
    ) {
      commit("SET_FACTOR", {
        user,
        description,
        tableNumber,
        goods,
        orderType,
        paymentType,
        discount,
      });
      console.log(goods);
    },
    setLocation({ commit }, { tableNumber, location }) {
      commit("SET_LOCATION", { tableNumber, location });
    },
    removeFactor({ commit }) {
      commit("REMOVE_FACTOR");
    },
    setNewFactorSum(
      { commit },
      {
        discount,
        paymentBeforDiscount,
        paymentAfterDiscount,
        tax,
        paymentAfterTax,
      }
    ) {
      commit("SET_NEW_FACTORSUM", {
        discount,
        paymentBeforDiscount,
        paymentAfterDiscount,
        tax,
        paymentAfterTax,
      });
    },
    setNewFactorHsale(
      { commit },
      {
        sho_Mobile,
        discount,
        locationCode,
        tedad,
        taF_NAME,
        orderType,
        desK_NUMBER,
        deliveryDelay,
        goods,
        companions,
        factoR_ID,
        payed,
        printeR_PORTABLE,
        printeR_KITCHEN,
        printeR_CASH,
        captaiN_ID,
        prinT_STATUS,
        paymenT_STATUS,
        saloonID,
        saloonName,
        mobile,
        description,
        maliat,
        maB_WITH_MALIAT,
        timE_FACTOR,
        datE_FACTOR,
        prinT_STATUS_CODE,
        pardakhT_STATUS,
        pardakhT_STATUS_CODE,
        iranI_STATUS,
        farangI_STATUS,
        paymentType,
        iranI_STATUS_CODE,
        farangI_STATUS_Code,
        paymessage,
        systemGOODS,
      }
    ) {
      commit("SET_NEW_FACTORHSALE", {
        sho_Mobile,
        discount,
        locationCode,
        tedad,
        taF_NAME,
        orderType,
        desK_NUMBER,
        deliveryDelay,
        goods,
        companions,
        factoR_ID,
        payed,
        printeR_PORTABLE,
        printeR_KITCHEN,
        printeR_CASH,
        captaiN_ID,
        prinT_STATUS,
        paymenT_STATUS,
        saloonID,
        saloonName,
        mobile,
        description,
        maliat,
        maB_WITH_MALIAT,
        timE_FACTOR,
        datE_FACTOR,
        prinT_STATUS_CODE,
        pardakhT_STATUS,
        pardakhT_STATUS_CODE,
        iranI_STATUS,
        farangI_STATUS,
        paymentType,
        iranI_STATUS_CODE,
        farangI_STATUS_Code,
        paymessage,
        systemGOODS,
      });
    },
  },
  modules: {
    cart,
  },
  getters: {
    isLoggedIn: (state) => state.token !== "",
    token: (state) => "Bearer " + state.token,
  },
});
